import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { TopBannerList } from '~/features/TopBannerList';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  return (
    <>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[{ label: 'コンテンツ配信' }, { label: 'バナー' }]}
      />
      <div className={styles.content}>
        <Suspense fallback={<Loader />}>
          <TopBannerList />
        </Suspense>
      </div>
    </>
  );
};
